import { IntuitiveIndication } from '@modules/rx-intuitive-teeth-orchestrator/models/intuitive-indication';
import { TREATMENT_PREVIEW_LINE_EMPTY } from './build-treatment-preview-line';
import { isImplantIndication } from '@shared/utils/procedure-type-util';

export const normalizeImplantsSummaryLine = (value: string | null | undefined): string | null => {
	if (value == null) {
		return null;
	}

	const t = value.trim();

	return t.length > 0 ? t : null;
};

/** Tooltip title for treatment list rows (list item base `attr.title`). */
export const buildTreatmentListPreviewTitle = (params: {
	readonly indicationId: IntuitiveIndication;
	readonly previewLine: string;
	readonly implantsSummaryLine: string | null;
}): string => {
	const { indicationId, previewLine, implantsSummaryLine } = params;
	const hasCrownTreatmentPreview = previewLine !== TREATMENT_PREVIEW_LINE_EMPTY;

	if (isImplantIndication(indicationId) && implantsSummaryLine != null) {
		if (hasCrownTreatmentPreview) {
			return `${implantsSummaryLine}\n${previewLine}`;
		}

		return implantsSummaryLine;
	}

	return previewLine;
};
